import 'chartjs-adapter-date-fns';

import { ChartData } from 'chart.js';
import { useEffect, useState } from 'react';

import { GaugeMetricEventsRequest } from '../../../../../admin-center/gen/mlops/gauge_metric/gaugemetric_pb';
import { useAdminCenterService } from '../../../../../admin-center/hooks';
import { useUser } from '../../../../../utils/hooks';
import {
  buildUserContext,
  lineChartOptions,
  NestedRawChartData,
  transformNestedDataForCharts,
} from '../../../common/utils';
import LineChart from '../../LineChart/LineChart';

interface MlopsGaugeMetricPlotProps {
  startDate: string;
  endDate: string;
  gaugeType: string[];
}

const gaugeMetricComponenstColorMap: Record<string, string> = {
  deployment: '#FF8FA3',
  dataset: '#FFAB91',
  experiment: '#E6EE9C',
  project: '#FFD54F',
  'registered-model': '#AED581',
  'registered-model-version': '#577337',
  user: '#80CBC4',
};

const GaugeMetricPlot = ({ startDate, endDate, gaugeType }: MlopsGaugeMetricPlotProps) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<ChartData<'line'> | null>(null);
  const service = useAdminCenterService();
  const user = useUser();

  useEffect(() => {
    const fetchGaugeMetricEvents = async () => {
      setLoading(true);
      try {
        const userContext = await buildUserContext(user);
        const request: GaugeMetricEventsRequest = {
          startDate: startDate,
          endDate: endDate,
          eventTypes: gaugeType,
          userContext: userContext,
        };
        const response = await service.getMlopsGaugeMetrics(request);
        const transformedEvents = transformNestedDataForCharts(
          response.data as NestedRawChartData,
          undefined,
          gaugeMetricComponenstColorMap
        );
        setData(transformedEvents);
      } catch (error) {
        console.error('Error fetching Gauge Metric events:', error);
        setError('Error fetching Gauge Metric events');
      } finally {
        setLoading(false);
      }
    };

    fetchGaugeMetricEvents();
  }, [startDate, endDate, gaugeType, service]);

  return (
    <div
      style={{
        width: '75%',
        margin: '1rem auto 0 auto',
      }}
    >
      <LineChart
        data={data}
        options={lineChartOptions('', data && data.labels?.length ? data.labels?.length : 0)}
        loading={loading}
        error={error ? true : false}
      />
    </div>
  );
};

export default GaugeMetricPlot;
